import { action } from 'satcheljs';

export const updateSelectedCalendarIds = action(
    'UPDATE_SELECTED_TIME_PANEL_CALENDARIDS',
    (calendarIds: string[]) => ({ calendarIds })
);
